import { AcceptFollow } from "@components/AcceptFollow";
import { ButtonSize } from "@components/Button";
import { Card } from "@components/Card";
import { FollowButton } from "@components/FollowButton";
import styled from "@emotion/styled";
import React, { useState } from "react";

import { UserResponse } from "@every.org/common/src/codecs/entities";
import { FollowRequestStatus } from "@every.org/common/src/entity/types";
import { getUserFullNameOrPlaceholder } from "@every.org/common/src/helpers/username";

import { spacing, verticalStackCss } from "src/theme/spacing";

const StyledCard = styled(Card)`
  ${verticalStackCss.xs};
`;

const FollowBackContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  > *:not(:last-child) {
    margin-right: ${spacing.xs};
  }
`;

/**
 * Card providing functionality to accept a follow request from the given user.
 * Returns empty component if there is no pending follow request.
 */
export const AcceptFollowCard: React.FCC<{ user: UserResponse }> = ({
  user,
}) => {
  const { followingCurrentUserStatus, followedByCurrentUserStatus } = user;
  const [acceptedFollow, setAcceptedFollow] = useState(false);

  if (followingCurrentUserStatus === FollowRequestStatus.UNSET) {
    return (
      <StyledCard>
        <AcceptFollow
          user={user}
          showRequestMessage
          onAccepted={() => {
            setAcceptedFollow(true);
          }}
        />
      </StyledCard>
    );
  } else if (
    acceptedFollow &&
    followedByCurrentUserStatus === FollowRequestStatus.NONE
  ) {
    return (
      <StyledCard>
        <FollowBackContent>
          <p>{getUserFullNameOrPlaceholder(user)} is now following you.</p>
          <FollowButton
            size={ButtonSize.SMALL}
            toFollowUserId={user.id}
            overrideButtonText={"Follow Back"}
            aria-label="Follow Back"
          />
        </FollowBackContent>
      </StyledCard>
    );
  }
  return null;
};
